
import { Component, Prop, Vue } from 'vue-property-decorator';
import { container } from '../../lib/container';
import { Actions, ActionStates } from '../../lib/Actions';
import { ContainerTypes } from '../../lib/core/types/ContainerTypes';
import { ResultEntry } from '../../lib/interfaces/search/ResultEntry';
import convertUnits from 'convert-units';
import { I18n } from '../../lib/interfaces/I18n';
import deDE from '../../lib/presets/resources/de-DE';
import { isResultEntry } from '../../lib/core/guards';

import { allowDevices, gtDevice } from '../../lib/core/responsive';
import { DetailsStorage } from '../../lib/core/storage/DetailsStorage';
import { setCmd, execCmd, emptyCmd } from '../../lib/core/storage/CommandStorage';
import { getConfig } from '../../lib/ConfigLoader';

import DetailsView from '../details-view.vue';
import EkomiStars from '../ekomi-stars.vue';
import { MutationTypes } from '../../store/mutation-types';

const actions = container.get<Actions>(ContainerTypes.Action);
const detailsStorage = container.get<DetailsStorage>(ContainerTypes.DetailsStorage);

actions.on(ActionStates.CallResults, (from, event) => execCmd('resultItemCallResults', from, event));

actions.on(ActionStates.CallDetails, (from, event) => execCmd('resultItemCallDetails', from, event));

@Component({
	components: { DetailsView, EkomiStars }
})
export default class ResultItem extends Vue {
	@Prop({ required: true })
	entry!: ResultEntry;

	isActive: boolean = false;
	isDetailInfo: boolean = false;

	i18n: I18n = deDE;

	$refs!: {
		resultContainer: HTMLDivElement;
		detailsView: DetailsView;
	};

	distance() {
		return convertUnits(parseFloat(this.entry.address.distance || '0'))
			.from('m')
			.to(this.i18n.lengthMeasurement)
			.toFixed(2);
	}

	distanceUnit() {
		return convertUnits().describe(this.i18n.lengthMeasurement).abbr;
	}

	openUntil() {
		const index = this.entry.businessHours.openAt[0].today.length - 1;
		return this.entry.businessHours.openAt[0].today[index].until;
	}

	isNonPublic() {
		return this.entry.branchCodes.some(bc => 'CPxDEGxNPB' === bc);
	}

	onDetailsClose() {
		this.isDetailInfo = false;
		this.isActive = false;
		detailsStorage.entry = null;
		this.$root.$emit('results:changed', this.isDetailInfo);
		this.$store.commit(MutationTypes.detailViewSelectMarker, {
			selectedMarker: null
		});
	}

	onDetailsOpen(event: Event) {
		event.preventDefault();
		const config = getConfig();
		if (!this.isActive) {
			if (config.resultsView.scrolling.autoScroll && allowDevices(config.resultsView.scrolling.sizes)) {
				this.isActive = true;
				this.isDetailInfo = this.isActive;
				this.$root.$emit('results:changed', this.isDetailInfo);
			}
			detailsStorage.entry = this.entry;
		}
		actions.go(ActionStates.CallDetails, {
			from: 'list',
			id: this.entry.idDecoded,
			isMarkerClick: false
		});

		this.$store.commit(MutationTypes.detailViewSelectMarker, {
			selectedMarker: this.entry.idDecoded,
			mode: 'full'
		});
	}

	handleCallTransition(from?: ActionStates, event?: any) {
		const config = getConfig();
		if (isResultEntry(detailsStorage.entry)) {
			const isActive = detailsStorage.entry.idDecoded === this.entry.idDecoded;
			if (isActive) {
				console.count('OPEN RESULT HANDLER');
				console.log('PARAMS', from, event);
				this.isActive = true;
				this.isDetailInfo =
					this.isActive &&
					config.resultsView.scrolling.autoScroll &&
					allowDevices(config.resultsView.scrolling.sizes);

				if (gtDevice('mobile')) {
					this.$refs.resultContainer.scrollIntoView({
						behavior: 'smooth',
						block: 'nearest'
					});
				} else {
					const app = document.querySelector('#app');
					if (app) {
						app.scrollIntoView({ behavior: 'smooth', block: 'start' });
					}
				}
			} else {
				this.isActive = false;
				this.isDetailInfo = false;
			}
		}
	}

	destroyed() {
		emptyCmd('resultItemCallDetails');
		emptyCmd('resultItemCallResults');
	}

	mounted() {
		this.$root.$on('results:changed', () => {
			if (this.entry !== detailsStorage.entry) {
				this.isActive = false;
				this.isDetailInfo = false;
			}
		});

		setCmd('resultItemCallResults', () => this.onDetailsClose());
		setCmd('resultItemCallDetails', (from, event) => this.handleCallTransition(from, event), false);
	}
}
